'use strict';

var customSpinnerJS = require('./custom/spinnerCustom');

module.exports = function () {
    customSpinnerJS.addSpinner();
    customSpinnerJS.removeSpinner();
};
